export * from './search-intense.component';
